/**
 * User: liliana
 * Date: 3/26/15
 * Time: 10:13 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

'use strict';

var SoaCollection            = require('bunsen/collections/SoaCollection');

/**
 * Collection for getting converted Financial Amounts
 **/
var FinancialAmountsConvert  = module.exports = SoaCollection.extend();

var _                        = require('underscore');
var FinancialAmount          = require('bunsen/models/FinancialAmount');
var endpoints                = require('dibs-endpoints');

_.extend(FinancialAmountsConvert.prototype, {
    model : FinancialAmount,

    // Use Backbone.sync('create' ...) to POST models and get converted currencies
    url : endpoints.currencyConvert()
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/FinancialAmountsConvert.js
// module id = 2608
// module chunks = 62